/**
 * Returns true if argument is a number and not NaN.
 * example:
 * i = 0; n = + 'x'; // i = 0, n = NaN.
 * typeof i === 'number'; // true
 * typeof n === 'number'; // true
 * Boolean(i) // false
 * Boolean(n) // false
 * isValidNumber(i) // true
 * isValidNumber(n) // false
 */
export default number => typeof number === 'number' && !isNaN(number);